import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

const feedbackCopy = {
  de: {
    triggerLabel: 'Feedback geben',
    formTitle: 'Feedback geben',
    nameLabel: 'Name',
    namePlaceholder: 'Dein Name',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'deine.email@beispiel.de',
    messageLabel: 'Beschreibung',
    messagePlaceholder: 'Was ist passiert?',
    submitButtonLabel: 'Feedback senden',
    cancelButtonLabel: 'Abbrechen',
    successMessageText: 'Vielen Dank für dein Feedback!',
  },
  en: {
    triggerLabel: 'Give feedback',
    formTitle: 'Give feedback',
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    emailPlaceholder: 'your.email@example.com',
    messageLabel: 'Description',
    messagePlaceholder: 'What happened?',
    submitButtonLabel: 'Send feedback',
    cancelButtonLabel: 'Cancel',
    successMessageText: 'Thank you for your feedback!',
  },
} as const

export default (app: App<Element>, locale: string) => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    return false
  }

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'unknown',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
      // TODO: enable browserTracingIntegration with custom routing
      // https://docs.sentry.io/platforms/javascript/tracing/instrumentation/automatic-instrumentation/#custom-routing
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'light',
        showBranding: false,
        ...feedbackCopy[locale === 'en' ? 'en' : 'de'],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // @see https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.5,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/app\.(dev\.)?finesthub\.de/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  return true
}
